<template>
  <div @click="openCTADialog()">
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsUnusualActivityCTADialog',
  data: () => ({
    show: false,
  }),
  computed: {
    ...mapGetters(['organizationId']),
  },
  methods: {
    close() {
      this.show = false;
    },
    open() {
      this.show = true;
    },
    openCTADialog() {
      window.analytics?.track('UA trial box opened');
      AjaxDialog.run(`/organizations/${this.organizationId}/insights/cta_dialog.dialog`);
    },
  },
};
</script>
